<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a [routerLink]="'/patients'">Home</a>
    </li>

    <li
      *ngFor="let breadcrumb of breadcrumbs; let last = last"
      class="breadcrumb-item"
      [class.active]="last"
    >
      <ng-container *ngIf="!last">
        <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
      </ng-container>
      <ng-container *ngIf="last">
        {{ breadcrumb.label }}
      </ng-container>
    </li>
  </ol>
</nav>
